import { sendHttp } from '../assets/js/request'

const loginApi = {
  // 执行登录
  doLogin (params) {
    return sendHttp('post', '/login', params)
  }
}

export { loginApi }



// WEBPACK FOOTER //
// ./src/apis/loginApi.js